export let GLOBAL = {
    url: 'http://ec2-52-212-104-120.eu-west-1.compute.amazonaws.com/api/'
};
